// packages/core/src/types/index.ts

/**
 * Core type definitions for Sharpee
 * These are generic types that can be used by any narrative system
 */

export * from './entity';
export * from './relationship';
export * from './attribute';
export * from './result';
export * from './save-data';
